<script>
import BaseFilter from "./BaseFilter";
import { mapGetters } from "vuex";

export default {
  name: "ServiceSearch",
  extends: BaseFilter,
  computed: {
    ...mapGetters({
      options: "services",
    }),
  },
  data() {
    return {
      placeholder: "Alle voorziening typen",
      filtername: "voorziening_typen",
      type: "voorziening typen",
    };
  },
};
</script>

